import { DashboardLayout } from 'layouts/dashboard/DashboardLayout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import CollectionGrid from 'components/CollectionGrid';

const Dashboard = () => {
  return (
    <DashboardLayout>
      <CollectionGrid publicView={false} />
    </DashboardLayout>
  );
};

export default Dashboard;
